<template>
  <q-card bordered class="q-pa-xs">

    <q-card-section>
      <div v-if="hasLoginFailed" class="text-caption q-mb-md">
        {{gettext('Last login failed on ') + new Date(loginFailed.date).toLocaleString()}}
      </div>
      <div v-if="loginSuccess!= null" class="text-caption">
        {{gettext('Last login success was on ') + new Date(loginSuccess.date).toLocaleString()}}
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
import dj_i18n from "@/services/django_i18n";
import { mapStores } from 'pinia';
import { useUserTokenStore } from '@/store/usertoken';   
import LoginService from "@/services/rest-auth";
import { useQuasar } from 'quasar';

export default {
  name : "LastLoginFeedback",
  mixins: [dj_i18n],
  setup() {
    const $q = useQuasar();
    return { 
      showNotif(msg) {
        $q.notify(msg);
      }
    }
  },
  data() {
    return {
    }
  },
  mounted() {
    const self = this;
    if(!this.usertokenStore.user.last_login_event){
      self.usertokenStore.setToken(self.$cookie.get("token"));
      LoginService.user().then(function(responseUser) {
        console.log(responseUser);
        const user = {
          ...responseUser.data,
          token: self.usertokenStore.token
        };
        console.log("store user = ", user);
        self.usertokenStore.setUser(user);
      }).catch(function(error){
        if (error.response) {
          self.showNotif(error.response); 
        }
      })
    }
  },
  computed:{
    ...mapStores(useUserTokenStore),

    hasLoginFailed() {
      return this.loginFailed != null;
    },

    loginFailed() {
      if (this.usertokenStore.user.last_login_event) {
        return this.usertokenStore.user.last_login_event.find(event => event.type_log == "LOGIN_FAILED");
      } 
      return null;
    },
    loginSuccess() {
      if(this.usertokenStore.user.last_login_event) {
        return this.usertokenStore.user.last_login_event.find(event => event.type_log == "LOGIN_SUCCESS");
      }
      return null;
    }
  }
}

</script>
